import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { GetStarted } from './pages/GetStarted';
import { SportDetail } from './pages/SportDetail';
import { Process } from './pages/Process';
import { TeamStores } from './pages/TeamStores';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
import { Wholesale } from './pages/Wholesale';
import { MockupRequest } from './pages/MockupRequest';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="sports/:sport" element={<SportDetail data-id="element-7" />} data-id="element-6" />
          <Route path="process" element={<Process data-id="element-9" />} data-id="element-8" />
          <Route path="get-started" element={<GetStarted data-id="element-11" />} data-id="element-10" />
          <Route path="team-stores" element={<TeamStores data-id="element-13" />} data-id="element-12" />
          <Route path="contact" element={<Contact data-id="element-15" />} data-id="element-14" />
          <Route path="about" element={<About data-id="element-17" />} data-id="element-16" />
          <Route path="wholesale" element={<Wholesale data-id="element-19" />} data-id="element-18" />
          <Route path="mockup-request" element={<MockupRequest data-id="element-21" />} data-id="element-20" />
        </Route>
      </Routes>
    </BrowserRouter>;
}